<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        :src="`${image_base_url}/img/avatars/1.png`"
        class="img-avatar"
        :alt="`${session.email}`" />{{this.session.name}}
    </template>\
    <template slot="dropdown">
      <b-dropdown-item v-on:click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>


<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import * as Auth from '@/shared/auth'

const envi = process.env

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      session: JSON.parse(Auth.session.get('session')),
      image_base_url: envi.VUE_APP_BASEURL
    }
  },
  methods: {
    logout() {
      Auth.session.delete()
      this.$router.push('/login')
      this.$toast.info('You have logged out', '', {
            position: 'topCenter',
            progressBarColor: 'rgb(0, 255, 184)',
            timeout: 5000
          })
    }
  }
}
</script>
